"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pCCErrorMessages = void 0;
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
exports.pCCErrorMessages = {
    required: () => i18next_1.default.t('P로 시작하는 숫자 12자리를 입력해주세요'),
    address: () => i18next_1.default.t('"배송지"를 등록해주세요'),
    invalid: () => i18next_1.default.t('실패: [배송지 이름/휴대폰 번호/개인통관고유부호] 명의 일치 필요'),
    unipassServer: () => i18next_1.default.t('실패: 관세청에 의해 업데이트 필요'),
};
function default_1(error, setError) {
    var _a, _b, _c, _d;
    const errorCode = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type;
    switch (errorCode) {
        case 40003:
            setError('second_customvalue', { type: 'invalid', message: exports.pCCErrorMessages.invalid() });
            const unipassMsg = ((_d = (_c = error.response.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.detail) || '';
            if (unipassMsg) {
                setError('root.unipassInvalid', {
                    type: 'detail',
                    message: unipassMsg,
                });
            }
            break;
        case 40001: // ! unipass 서버 에러
        case 40002:
        case 40004:
            setError('second_customvalue', {
                type: 'unipassServer',
                message: exports.pCCErrorMessages.unipassServer(),
            });
            break;
        default:
            alert((0, errors_1.commonErrorMsg)());
    }
}
exports.default = default_1;
